import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getRecord, update as updateRecord} from "app/requests/admin/cases";
import Loading from "components/pages/loading";
import {valueFrom, valueFromTarget} from "lib/form";
import useAppContext from "lib/hooks/use-app-context";
import usePrompt from "lib/hooks/use-prompt";
import Form from "./form";

export default function AdminCasesEdit() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const {id} = useParams();
  const [block, setBlock] = useState(false);
  const [changes, setChanges] = useState({});
  const [record, setRecord] = useState(null);
  const onChange = ({target}) => {
    setBlock(true);
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (e) => {
    e.preventDefault();

    if(Object.keys(changes).length === 0) {
      return dispatch(createNotification({
        content: "Please make changes before submitting",
        type: "error"
      }));
    }

    const {case_tags: caseTags, questions, ...recordChanges} = changes;
    if(caseTags) { recordChanges.case_tags_attributes = caseTags; }
    if(questions) { recordChanges.questions_attributes = questions; }

    setBlock(false);
    updateRecord(record.id, {case: recordChanges}).then(({message, success}) => {
      if(success) {
        navigate("/admin/cases", {message, type: "success"});
      } else {
        dispatch(createNotification({content: message, type: "error"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({defaultValue, name, objects: [changes, record]});

  usePrompt({when: block});
  useEffect(() => {
    getRecord(id).then((data) => setRecord(data.case));
  }, []);

  if(!record) { return <Loading />; }

  return (
    <div>
      <h1 className="text-center">Edit Case</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
